module.exports = __webpack_public_path__ + "img/prize-03.b6eeeccd.png";